import * as yup from "yup";
import type { Schema } from "yup";

export interface INotificationFormValues {
  title: string;
  content: string;
  centers: string[];
  segments: string[];
  profiles: string[];
  startAt: string; // ISO ou datetime-local
  expireAt: string;
  fileKey?: string | null;
  fileType?: string | null;
}

const atLeastOneRecipient = function (this: yup.TestContext) {
  const parent = this.parent as INotificationFormValues;
  const { centers = [], segments = [], profiles = [] } = parent;
  return centers.length > 0 || segments.length > 0 || profiles.length > 0;
};

export const notificationFormSchema = yup
  .object({
    title: yup.string().trim().required("Título é obrigatório"),
    content: yup.string().trim().required("Mensagem é obrigatória"),

    centers: yup
      .array()
      .of(yup.string().trim().required())
      .test(
        "at-least-one-recipient",
        "Selecione pelo menos um destinatário (centro, segmento ou perfil)",
        atLeastOneRecipient
      )
      .default([]),

    segments: yup
      .array()
      .of(yup.string().trim().required())
      .test(
        "at-least-one-recipient",
        "Selecione pelo menos um destinatário (centro, segmento ou perfil)",
        atLeastOneRecipient
      )
      .default([]),

    profiles: yup
      .array()
      .of(yup.string().trim().required())
      .test(
        "at-least-one-recipient",
        "Selecione pelo menos um destinatário (centro, segmento ou perfil)",
        atLeastOneRecipient
      )
      .default([]),

    startAt: yup.string().required("Vigência inicial é obrigatória"),
    expireAt: yup
      .string()
      .required("Vigência final é obrigatória")
      .test(
        "end-after-start",
        "A vigência final não pode ser menor que a inicial",
        function (value) {
          const { startAt } = this.parent as INotificationFormValues;

          if (!startAt || !value) return true;

          const start = new Date(startAt);
          const end = new Date(value);

          if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
            return true;
          }

          return end >= start;
        }
      ),

    fileKey: yup.string().nullable().optional(),
    fileType: yup.string().nullable().optional(),
  })
  .required() as Schema<INotificationFormValues>;

// valores inicial do formulario de notification
export const formInitialValues: INotificationFormValues = {
  title: "",
  content: "",
  centers: [],
  segments: [],
  profiles: [],
  startAt: "",
  expireAt: "",
  fileKey: null,
  fileType: null,
};
